import React, { ButtonHTMLAttributes, LinkHTMLAttributes } from 'react';
import clsx from 'clsx';

interface CommonProps {
  fullWidth?: boolean;
  buttonRef?: React.RefObject<any>;
  variant?: 'contained' | 'outlined' | 'link';
}
interface ButtonProps
  extends CommonProps,
    ButtonHTMLAttributes<HTMLButtonElement> {
  tag?: 'button';
}
interface LinkButtonProps
  extends CommonProps,
    LinkHTMLAttributes<HTMLAnchorElement> {
  tag: 'a';
}

type ButtonComponentProps = ButtonProps | LinkButtonProps;

export const Button = (props: ButtonComponentProps) => {
  const { variant = 'contained' } = props;

  const btnVariant = {
    'bg-button-primary text-white disabled:bg-primary-disabled dark:bg-primary-dark dark:text-dark dark:disabled:opacity-50':
      variant === 'contained',
    'bg-white text-primary disabled:text-primary-disabled disabled:border-primary-disabled dark:border-primary-dark dark:text-primary-dark dark:bg-dark border border-solid border-primary disabled:border-primary-disabled':
      variant === 'outlined',
    'bg-transparent text-primary disabled:text-primary-disabled border-0 dark:text-primary-dark':
      variant === 'link',
    'w-full': props.fullWidth,
    'inline-block text-center': props.tag === 'a',
  };

  const btnClassName = clsx(
    'rounded-full px-4 py-3 font-semibold',
    btnVariant,
    props.className,
  );

  if (props.tag === 'a') {
    const { className, children, fullWidth, tag, ...otherProps } = props;
    return (
      <a className={btnClassName} {...otherProps}>
        {children}
      </a>
    );
  }

  const { className, children, fullWidth, tag, buttonRef, ...otherProps } =
    props;
  return (
    <button className={btnClassName} ref={buttonRef} {...otherProps}>
      {children}
    </button>
  );
};
